export enum FaqActionTypes {
    SET = '@@faq/SET'
}

export interface IFaqState {
    type: string | null;
}
